import { DistributionChannel } from '@ail/notifications-api'
import { useTranslation } from 'react-i18next'
import { PermissionsEnum } from '../../types/enums'
import {
  ChannelSettingKey,
  NotificationChannelsState,
  SETTINGS,
  toggleChannel,
} from '../AdminPanel/UsersAdminPanel/UserEdit/NotificationSettings/NotificationSettingsUtils'

export function UserNotificationSettings(props: {
  channels: NotificationChannelsState
  onChannelsChange: (next: NotificationChannelsState) => void
  userPermissions: string[]
}) {
  const { t } = useTranslation('common')
  const { channels, onChannelsChange, userPermissions } = props

  const visibleSettings = SETTINGS.filter(
    ({ requiredPermission }) =>
      requiredPermission === null || userPermissions.includes(requiredPermission as PermissionsEnum)
  )

  const handleToggle = (key: ChannelSettingKey, channel: DistributionChannel) => {
    onChannelsChange({ ...channels, [key]: toggleChannel(channels[key], channel) })
  }

  return (
    <div className="col-12 settings-section notification-settings">
      <div className="roles">
        <div className="popTitle">
          <div>
            <i className="icon-alert" />
            {t('NOTIFICATIONS')}
          </div>
        </div>
        <ul className="notif-settings-list">
          {visibleSettings.map(({ key, labelKey, icon }) => {
            const active = channels[key]
            return (
              <li key={key} className="notif-settings-row">
                <label>
                  <i className={icon}></i>
                  {t(labelKey)}
                </label>
                <div className="input-group">
                  <i
                    className={`icon-alert notif-icon-toggle ${
                      active.includes(DistributionChannel.Native) ? 'active' : ''
                    }`}
                    onClick={() => handleToggle(key, DistributionChannel.Native)}
                  ></i>
                  <i
                    className={`icon-mail notif-icon-toggle ${
                      active.includes(DistributionChannel.Email) ? 'active' : ''
                    }`}
                    onClick={() => handleToggle(key, DistributionChannel.Email)}
                  ></i>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
